import { ErrorInfo, ReactNode } from 'react';
import * as React from 'react';

import PropTypes from 'prop-types';

import DefaultError from '../../route/ErrorFallback';

interface States {
  error: Error | null;
  info: ErrorInfo | null;
}

interface Props {
  children: ReactNode;
  Fallback?: React.FC<{ error: States['error']; info: States['info'] }>;
  // customerServiceUrl: string; // [移除] 不再需要傳入
}

export default class ErrorBoundary extends React.Component<Props, States> {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.node.isRequired,
    Fallback: PropTypes.node,
    // customerServiceUrl: PropTypes.string.isRequired, // [移除] 檢查
  };

  constructor(props: Props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error: States['error'], info: States['info']) {
    this.setState({ error, info });
  }

  render() {
    const { error, info } = this.state;
    const { children, Fallback } = this.props; // [移除] 這裡也不解構 customerServiceUrl

    if (error) {
      if (Fallback) {
        return <Fallback error={error} info={info} />;
      }
      // [移除] 這裡不再傳遞參數給 DefaultError (ErrorFallback)
      return <DefaultError error={error} />;
    }

    return children;
  }
}